<template>
    <div class="checkout-delivery-cities">
        <DefSelectSearch
            :required="true"
            :value="result && result.UF_NAME"
        >
            <template #header>
                {{ result && result.UF_NAME }}
            </template>
            <template #placeholder>
                {{ messages.city }}
            </template>
            <template #search>
                <input
                    type="text"
                    @input="handlerInput"
                    :placeholder="messages.writeNameCity"
                >
            </template>
            <div
                v-for="city in cities"
                @click="$emit('changeCity', city)"
            >
                {{ city.UF_NAME }}
            </div>
        </DefSelectSearch>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import DefSelectSearch from "../../../def/DefSelect/DefSelectSearch";

export default {
    name: 'CheckoutDeliveryCities',
    props: ['result'],
    components: {
        DefSelectSearch
    },
    data() {
        return {
            timeoutId: null,
        }
    },
    computed: {
        ...mapState({
            cities: ({ cities }) => cities.data.cities,
            messages: ({ checkout }) => checkout.data.vue.delivery.messages,
            items: ({ checkout }) => checkout.data.vue.delivery.items,
        }),
        isActiveShops() {
            const items = this.items;
            let response = false;

            for (let key in items) {
                const item = items[ key ]
                if (item.ID == 2 && item.CHECKED === 'Y') {
                    response = true;
                }
            }

            return response;
        },
    },
    methods: {
        ...mapActions({
            getCitiesWithShops: 'cities/getCitiesWithShops',
            getCities: 'cities/getCities',
        }),
        updateCities(value) {
            if (this.isActiveShops) {
                this.getCitiesWithShops(value);
            } else {
                this.getCities(value);
            }
        },
        handlerInput({ target: { value } }) {
            clearTimeout(this.timeoutId);
            this.timeoutId = setTimeout(() => this.updateCities(value), 300);
        },
    },
    // mounted() {
    //     this.$emit('changeCity', this.result);
    // },
    // beforeUnmount() {
    //     this.$emit('changeCity');
    // }
}
</script>

<style lang="scss" scoped>
.checkout-delivery-cities{
    margin-bottom: 16px;
}
</style>